import { Injectable } from '@angular/core';
import { DataModuleWithRelations, NewModule } from '@osos/shared/api';
import {
  ApplicationSharingLevelEnum,
  DataModulePresenterModel,
} from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class DataModuleParserV1Service extends ParserBase<
  Partial<DataModuleWithRelations & NewModule>,
  DataModulePresenterModel
> {
  constructor() {
    super(DataModuleWithRelations, DataModulePresenterModel, 1);
  }
  getPresenterModel(
    model: Partial<DataModuleWithRelations & NewModule>,
  ): DataModulePresenterModel {
    const presenter = {
      specificationVersion: this.version,
    } as DataModulePresenterModel;
    presenter.icon = model.icon;
    presenter.id = model.id;
    presenter.name = model.name;
    presenter.description = model.description;
    presenter.normalizedName = model.normalizedName;
    presenter.isImplicit = model.isImplicit;
    presenter.permissions = model.permissions;
    presenter.sharing = {
      ...model.sharing,
      level: model.sharing?.level?.id as ApplicationSharingLevelEnum,
    };
    return presenter;
  }
  getDataModel(
    presenter: DataModulePresenterModel,
  ): Partial<DataModuleWithRelations & NewModule> {
    const model = {
      icon: presenter.icon,
      name: presenter.name,
      description: presenter.description,
      normalizedName: presenter.normalizedName,
      isImplicit: presenter.isImplicit,
      permissions: presenter.permissions,
      specificationVersion: this.version,
      sharing: {
        ...presenter.sharing,
        level: {
          id: presenter.sharing.level,
        },
      },
    } as Partial<DataModuleWithRelations & NewModule>;

    return model;
  }
}
